import { render, staticRenderFns } from "./ProfileVerifications.vue?vue&type=template&id=4d876a79&scoped=true&"
import script from "./ProfileVerifications.vue?vue&type=script&lang=js&"
export * from "./ProfileVerifications.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVerifications.vue?vue&type=style&index=0&id=4d876a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d876a79",
  null
  
)

export default component.exports